const semver = require('semver');

module.exports = semver.satisfies(process.version, '>=15.7.0');



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/lib/asymmetricKeyDetailsSupported.js
// module id = 1913
// module chunks = 1